import api from "@/api/api";
import { STATUS_HTTP } from "@/api/statusHTTP";
import { iniciarRequisicao, logout } from "@/helpers";

const PREFIXO = '/compras/detalhes-produto';

export const buscarDadosTransferenciaProduto = async (parametros) => {
  const url = `${PREFIXO}/transferencia-do-produto`;

  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.dados;
}
